import { SERVICE_NAME } from '../../constants';
import type { Nullable } from '../../types';

export const CHANGE_PAGE_EVENT_PREFIX = 'change:page:';

/**
 * ButtonModel model, according to Asset Based Architecture
 * @param id - ButtonID
 * @param title - 'btn-title' property of ButtonModel
 * @link https://confluence.pm.tech/display/ARCH/Events
 */
export class PageEventButton {
  public id: string;
  public title: string;

  constructor(id: string, title = '') {
    this.id = id;
    this.title = title;
  }

  toObject() {
    return {
      'btn-title': this.title,
      'callback-message': {
        data: { id: this.id, target: SERVICE_NAME },
      },
    };
  }
}

/**
 * ChangePagePayload model, according to Asset Based Architecture
 * @param {string} id - tile part of Event "id" property.
 * @param {string} title - used for "page-title" property.
 * @param {PageEventButton} primaryButton - button object, which should be shown on the right
 * @param {PageEventButton} secondaryButton - button object, which should be shown on the left
 * @link https://confluence.pm.tech/display/ARCH/Events
 */
export class PageEvent {
  public id: string;
  public title: string;
  public primaryButton: Nullable<PageEventButton>;
  public secondaryButton: Nullable<PageEventButton>;

  constructor(
    id: string,
    title: string,
    primaryButton = null,
    secondaryButton = null
  ) {
    this.id = id;
    this.title = title;
    this.primaryButton = primaryButton;
    this.secondaryButton = secondaryButton;
  }

  toObject() {
    return {
      id: `${CHANGE_PAGE_EVENT_PREFIX}${this.id}`,
      event: {
        origin: '*',
        'page-title': this.title,
        primary: this.primaryButton,
        secondary: this.secondaryButton,
        additional: null,
        'additional-two': null,
      },
    };
  }
}

/**
 * ChangePagePayload model, according to Asset Based Architecture
 * @param {string|number} status - used as id and title for PageEvent
 * @link https://confluence.pm.tech/display/ARCH/Events
 */
export class StatusPageEvent extends PageEvent {
  constructor(status: string | number) {
    super(status.toString(), status.toString());
  }
}
